


























































































































import { Component, Prop, Vue } from "vue-property-decorator"
import QuestionFormFields from "./QuestionFormFields.vue"
import QuestionTransfer from "./QuestionTransfer.vue"
import { mapState } from 'vuex'
import { STATUSES } from "@/constants/question_group"

@Component({
  components: {
    QuestionFormFields,
    QuestionTransfer
  },
  computed: {
    ...mapState("QuestionGroup", {
      questionGroup: "questionGroup"
    })
  }
})
export default class QuestionList extends Vue {
  @Prop({ type: Array, default: () => [] }) readonly list!: Model[]
  @Prop({ type: Boolean, default: false }) readonly displayItems!: boolean

  questionGroup!: Model
  statuses = STATUSES

  drawer = false
  dialog = false
  isLoading = false
  selectedObjectId = null
  search = ""

  // Data Table Headers
  headers = [
    {
      text: "ID",
      align: "left",
      sortable: false,
      value: "bridge.id"
    },
    {
      text: "Name",
      align: "left",
      sortable: false,
      width: "35%"
    },
    {
      text: "Internal Annotation",
      align: "left",
      sortable: false,
      width: "25%"
    },
    {
      text: "Type",
      align: "left",
      sortable: false
    },
    {
      text: "Action",
      sortable: false
    }
  ]

  // Move up the question
  handleUp(item) {
    const index = this.getIndex(item)
    const list: Model[] = Object.assign([], this.list)
    const prevItem = list[index - 1]
    list[index - 1] = list[index]
    list[index] = prevItem

    const action = !this.displayItems
      ? "QuestionGroup/sortLibrary"
      : "QuestionGroup/sortImpactedTargets"

    this.$store.dispatch(action, {
      objectId: this.$route.params.questionGroupOid,
      config: {
        list: list.map((item: Model) => {
          return item.object_id
        })
      }
    })
  }

  // Move down the question
  handleDown(item) {
    const index = this.getIndex(item)
    const list: Model[] = Object.assign([], this.list)
    const nextItem = list[index + 1]
    list[index + 1] = list[index]
    list[index] = nextItem

    const action = !this.displayItems
      ? "QuestionGroup/sortLibrary"
      : "QuestionGroup/sortImpactedTargets"

    this.$store.dispatch(action, {
      objectId: this.$route.params.questionGroupOid,
      config: {
        list: list.map((item: Model) => {
          return item.object_id
        })
      }
    })
  }

  // Set selected question and open the bottom sheet
  handleEdit(question) {
    this.$store.commit("Question/SET_QUESTION", question)
    this.drawer = true
  }

  confirmDelete(objectId) {
    this.dialog = true
    this.selectedObjectId = objectId
  }

  // Delete question
  async handleDelete() {
    this.isLoading = true
    await this.$store.dispatch("Question/delete", this.selectedObjectId)
    this.isLoading = false
    this.selectedObjectId = null
    this.dialog = false
  }

  filterList(value, search, item) {
    return item.bridge.body.toLowerCase().includes(search)
  }

  getIndex(item) {
    return this.list.findIndex(
      listItem => listItem.object_id === item.object_id
    )
  }
}
